export const BORROWER_SIDEBAR_FORM_TYPES = {
  // BANK_ACCOUNT: "BANK_ACCOUNT",
  // EXPERIENCE: "EXPERIENCE",
  // ENTITY: "ENTITY",
  ADD_BANK_ACCOUNT: "Add Bank Account",
  ADD_EXPERIENCE: "Add Experience",
  ADD_ENTITY: "Add Entity",
  UPDATE_BANK_ACCOUNT: "Update Bank Account",
  UPDATE_ENTITY: "Update Entity",
  UPDATE_EXPERIENCE: "Update Experience",
  UPDATE_DOCUMENT_METADATA: "Update Document",
  UPDATE_PROFILE_DATA: "Update Profile",
  UPDATE_PERMITTED_USERS: "Update Permitted Users",
};
